import { render } from "./IssueArticleContent.vue?vue&type=template&id=1c902f41"
import script from "./IssueArticleContent.vue?vue&type=script&lang=js"
export * from "./IssueArticleContent.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3963854441/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__